<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:23:25
 * @LastEditors: yd
 * @LastEditTime: 2020-11-17 10:42:58
-->
<template>
  <div>
    <mrc_ess_table v-if="$route.name == 'staffOfficial'" :headers="headers" pageName="addStaffOfficial"
      :paginationOptions="options" @turnPage="getlist" :hideAddBtn="!hasBtn('add-staff-probation')" :isLoading="loading"
      :slotKey="['name', 'employment_date', 'probation_end_date']" :items="desserts">
      <template v-slot:search>
        <v-row class="d-flex justify-end" style="background: white;
          margin: 0;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;padding: 0 16px">
          <mrc_ess_advanceFilterAndSearchInput class="mt-4" v-model="systemSeniorQueryString"
            @success="getlist({ cpage: 1 })" :systemFieldMeta="systemFieldMeta"></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>
      <template v-slot:item.name="{ item }">
        <mrc_ess_staffListView :staffObj="item"></mrc_ess_staffListView>
      </template>
      <template v-slot:item.employment_date="{ item }">
        {{ item.employment_date | changeDate() }}
      </template>
      <template v-slot:item.probation_end_date="{ item }">
        {{ item.probation_end_date | changeDate() }}
      </template>
      <!-- 操作 -->
      <template v-slot:item.actions="{ item }">
        <menu-list :list="menulist" @handleClick="handleClick($event, item)">
          <template v-slot:showAction>
            <v-icon v-btnAuth="[
              'view-staff-probation',
              'edit-staff-probation',
              'delete-staff-probation',
            ]">mdi-dots-vertical</v-icon>
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <router-view v-else></router-view>
    <mrc_ess_myDialog v-model="dialog" :title="$t('label_Upload_CVS')" width="847" :disabled="false">
      <mrc_ess_myStep :list="stepList" v-model="stepIndex">
        <template v-slot:1>
          <span>
            文件
          </span>
          <mrc_ess_brandupload :isShow="false"></mrc_ess_brandupload>
          <mrc_ess_submitBtn @success="changeIndex(2)" :successText="$t('label_The_next_step')" @cancel="changeIndex(0)">
          </mrc_ess_submitBtn>
        </template>
        <template v-slot:2>
          <mrc_ess_submitBtn @success="changeIndex(3)" :cancel="$t('label_The_previous_step')" @cancel="changeIndex(1)">
          </mrc_ess_submitBtn>
        </template>
      </mrc_ess_myStep>
    </mrc_ess_myDialog>
  </div>
</template>

<script>
import {
  getStaffOfficialList,
  addStaffOfficial,
  updateStaffOfficial,
  deleteStaffOfficial,
  detailStaffOfficial,
} from "@/service/api/staffmsg.js"
import { getStaffListForFilter } from "@/service/api/autoComplete.js"
import { getBusinessList } from "@/service/api/prompt.js"
export default {
  components: {},
  props: {},
  data() {
    return {
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      stepIndex: 1,
      dialog: false,
      disabled: true,
      list: {},
      options: {
        pagesize: 5, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
      },
      loading: false,
      desserts: [],
    }
  },
  computed: {
    complete_probation() {
      //员工转正参照
      return {
        prompt_name: "complete_probation",
        org_level_uuid: this.$store.state.currentCompany,
      }
    },
    stepList() {
      return [
        {
          name: this.$t("label_Importing_files"),
        },
        {
          name: this.$t("label_result"),
        },
      ]
    },
    menulist() {
      return [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("view-staff-probation"),
          type: "view",
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("edit-staff-probation"),
          type: "edit",
        },
        {
          name: this.$t("label_delete"),
          show: this.hasBtn("delete-staff-probation"),
          type: "del",
        },
      ]
    },
    headers() {
      return [
        {
          text: this.$t("label_Turn_the_person"),
          align: "start",
          value: "name",
          sortable: false,
        },
        {
          text: this.$t("label_The_date_of_entry_to_the_company"),
          value: "employment_date",
          sortable: false,
          align: "center",
          width: "200",
        },
        {
          text: this.$t("label_The_positive_date"),
          value: "probation_end_date",
          sortable: false,
          align: "center",
          width: "200",
        },
        {
          text: "",
          value: "actions",
          sortable: false,
          align: "end",
          width: "100",
        },
      ]
    },
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1)
  },
  async created() {
    await this.getBtnPermissionList()
  },
  watch: {
    $route(v) {
      if (v.name == "staffOfficial") {
        this.getlist()
      }
    },
  },
  async mounted() {
    this.loading = true
    await this.getdropDownList()
    await this.getlist()
    this.loading = false
  },
  beforeDestroy() {
    this.$ls.remove("staffList")
  },
  methods: {
    async getdropDownList() {
      const res = await getBusinessList(this.complete_probation)
      // const res = await getStaffListForFilter({
      //   org_level_uuid: this.$store.state.currentCompany
      // })
      // getStaffListForFilter({
      //   org_level_uuid: this.$store.state.currentCompany
      // }).then(res => {
      //   console.log(res);
      //   this.dropDownList = res.data
      // })
      if (res.code == 200) {
        this.allList = res.data
      }
    },
    changeIndex(v) {
      if (v == 0) {
        this.dialog = false
      } else if (v == 3) {
        //提交代码逻辑
      } else {
        this.stepIndex = v
      }
    },
    async getlist(obj) {
      this.loading = true
      if (
        this.desserts &&
        this.desserts.length == 1 &&
        this.options.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.options.cpage--
      if (obj) {
        const { cpage, pagesize } = obj
        this.options = { ...this.options, ...obj }
      }
      const res = await getStaffOfficialList({
        cpage: this.options.cpage,
        pagesize: this.options.pagesize,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      })
      if (res.code == 200) {
        this.desserts = res.data
        this.options.totalcount = res.totalcount
        this.options.totalpage = res.totalpage
        this.systemFieldMeta = res.systemFieldMeta
        this.field_alias_name = res.field_alias_name
        this.table_alias_name = res.table_alias_name
      }
      this.loading = false
    },
    addStaffOfficial() {
      this.$store.commit("set_subPage_name", "")
      this.$store.commit("set_uuid", "")
      this.$store.commit("set_iconstatus", "") //行内进图标显示
      this.$router.push({
        name: "addStaffOfficial",
      })
    },
    godetail(item) {
      this.$store.commit("set_iconstatus", true) //行内进图标显示
      this.$store.commit("set_subPage_name", item.show_name)
      this.$store.commit("set_uuid", item.uuid) //
      this.$router.push({
        name: "detailStaffOfficial",
      })
    },
    handleClick({ item }, obj) {
      switch (item.type) {
        case "view":
          this.godetail(obj)
          break
        case "edit":
          this.$store.commit("set_subPage_name", obj.show_name)
          this.$store.commit("set_iconstatus", false) //行内进图标显示
          this.$store.commit("set_uuid", obj.uuid) //
          this.$router.push({
            name: "detailStaffOfficial",
          })
          break
        case "del":
          this.$myConfirm({
            content: this.$t("message_Confirm_the_deletion"),
          }).then((res) => {
            deleteStaffOfficial({ uuid: obj.uuid }).then((res) => {
              if (res.code === "200") {
                this.$Message({
                  text: this.$t("message_The_deletion_was_successful"),
                })
                if (this.desserts.length == 1) this.options.cpage--
                this.getlist()
              }
            })
          })
          break
      }
    },
    success() { },
    cancel() { },
  },
}
</script>

<style scoped>
.cardtitle {
  position: relative;
}

.emailbtn {
  position: absolute;
  right: 70px;
  top: -50px;
}

.dowanTemplate {
  position: absolute;
  right: 180px;
  top: -50px;
}
</style>
